<template>
  <div class="instagram">
    <div v-for="image in limitedImages()" :key="image.id" class="square" :style="{width: imageWidthPercent(), margin: imageMarginPercent() }">
      <img :src="image.url" class='image'>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instagram',
  data () {
    return {
      images: [],
      imageColumnCount: 2,
      imageRowCount: 6,
      username: 'unknown'
    }
  },
  methods: {
    fetchImages: function () {
      this.$http.get('https://tnzdna0h8c.execute-api.us-east-1.amazonaws.com/production/instagram/' + this.username).then(response => {
        this.images = response.body.images
      }, response => {
        console.log("things didn't go well")
      })
    },

    imageWidthPercent: function () {
      var widthPercent = 99 / this.imageColumnCount
      return widthPercent + '%'
    },
    imageMarginPercent: function () {
      var marginPercent = 1 / (this.imageColumnCount * 2 + 1)
      return marginPercent + '%'
    },
    maxImages: function () {
      return this.imageColumnCount * this.imageRowCount // this.widthCount
    },
    limitedImages: function () {
      if (this.images !== undefined) {
        return this.images.slice(0, this.maxImages())
      } else {
        return []
      }
    }
  },
  mounted () {
    this.username = this.$route.params.username
    this.fetchImages()
  }
}
</script>

<style >

#instagram {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  text-align: center;
  color: #000;
  margin: auto;
}

.square {
  float:left;
  border: 0px solid #CCC;
  margin: 1px;
  position: relative;
  width: 49%;
  overflow-y: hidden;
  background: #CCC;
}

.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.square-enter-active, .square-leave-active {
  transition: all 2s;
}
.square-enter, .square-leave-active {
  opacity: 0;
  /* transform: translateY(30px);*/
}

.image {
  position: absolute;
  left: 0;
  width: 100%;
}

.made-with {
  color: #DDD;
  font-size: 9pt;
  position: relative;
  text-align: left;
  left: 5px;
  top: 0px;
}
.made-with a {
  color: #DDD;
}

.link {
  text-decoration: underline;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Instagram.vue